import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async lookupCnpj(event) {
    const raw = event.target.value.replace(/\D/g, "");
    if (raw.length !== 14) return;

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${raw}`);
      if (!response.ok) return;
      const data = await response.json();

      const form = event.target.closest("form");
      this.setField(form, "RazaoSocial", data.razao_social);
      this.setField(form, "Logradouro", `${data.descricao_tipo_de_logradouro || ""} ${data.logradouro || ""}`.trim());
      this.setField(form, "Bairro", data.bairro);
      this.setField(form, "Município", data.municipio);
      this.setField(form, "Estado", data.uf);
      this.setField(form, "CEP", data.cep);
      this.setField(form, "CNAE", data.cnae_fiscal_descricao);
      this.setSelect(form, "tipo", data.identificador_matriz_filial === 1 ? "Matriz" : "Filial");
      this.setSelect(form, "Is_simples", data.opcao_pelo_simples ? "Sim" : "Não");
    } catch (e) {
      console.error("Erro ao consultar CNPJ:", e);
    }
  }

  async lookupCep(event) {
    const raw = event.target.value.replace(/\D/g, "");
    if (raw.length !== 8) return;

    let data = null;
    try {
      const v2 = await fetch(`https://brasilapi.com.br/api/cep/v2/${raw}`);
      if (v2.ok) data = await v2.json();
    } catch (e) {
      // tenta fallback
    }

    if (!data) {
      try {
        const v1 = await fetch(`https://brasilapi.com.br/api/cep/v1/${raw}`);
        if (v1.ok) data = await v1.json();
      } catch (e) {
        console.error("Erro ao consultar CEP:", e);
        return;
      }
    }
    if (!data) return;

    const form = event.target.closest("form");
    this.setField(form, "Logradouro", data.street);
    this.setField(form, "Bairro", data.neighborhood);
    this.setField(form, "Município", data.city);
    this.setField(form, "Estado", data.state);
  }

  setField(form, key, value) {
    if (!form || !value) return;
    const input = form.querySelector(`[name$="[${key}]"]`);
    if (input) input.value = value;
  }

  setSelect(form, key, textToMatch) {
    if (!form || !textToMatch) return;
    const select = form.querySelector(`select[name$="[${key}]"]`);
    if (!select) return;
    for (const option of select.options) {
      if (option.text.trim().toLowerCase() === textToMatch.toLowerCase()) {
        select.value = option.value;
        break;
      }
    }
  }
}
